import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { LayoutPageComponent } from './componenets/layout-page/layout-page.component';
import { HomePageComponent } from './componenets/home-page/home-page.component';
import { StartupPageComponent } from './componenets/startup-page/startup-page.component';
import { IncubatorsListComponent } from './componenets/startup-page/incubators-list/incubators-list.component';
import { IncubatorsDetailsComponent } from './componenets/startup-page/incubators-details/incubators-details.component';
import { EventsPageComponent } from './componenets/events-page/events-page.component';
import { GalleryPageComponent } from './componenets/gallery-page/gallery-page.component';
import { BlogPageComponent } from './componenets/blog-page/blog-page.component';
import { ContactPageComponent } from './componenets/contact-page/contact-page.component';
import { NavbarComponent } from './componenets/layout-page/navbar/navbar.component';
import { FooterComponent } from './componenets/layout-page/footer/footer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { IonicModule } from '@ionic/angular';
import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';
import { LoginPageComponent } from './componenets/auth/login-page/login-page.component';
import { RegisterPageComponent } from './componenets/auth/register-page/register-page.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { EventListComponent } from './componenets/events-page/event-list/event-list.component';
import { EventDetailsComponent } from './componenets/events-page/event-details/event-details.component';
import { SafeHtmlPipe } from './safe-html.pipe';
import { BlogListComponent } from './componenets/blog-page/blog-list/blog-list.component';
import { BlogDetailsComponent } from './componenets/blog-page/blog-details/blog-details.component';
import { BrochureViewComponent } from './componenets/startup-page/incubators-details/brochure-view/brochure-view.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ProfilePageComponent } from './componenets/pages/profile-page/profile-page.component';
import { IncubatorListComponent } from './componenets/pages/incubator-list/incubator-list.component';
import { GoogleMapDialogBoxComponent } from './componenets/pages/profile-page/google-map-dialog-box/google-map-dialog-box.component';
import { YoutubeDialogBoxComponent } from './componenets/pages/profile-page/youtube-dialog-box/youtube-dialog-box.component';
import { TermsPageComponent } from './componenets/layout-page/terms-page/terms-page.component';
import { PolicyPageComponent } from './componenets/layout-page/policy-page/policy-page.component';
import { SearchPageComponent } from './componenets/pages/search-page/search-page.component';
import { IncuNewslettersComponent } from './componenets/startup-page/incubators-details/incu-newsletters/incu-newsletters.component';
import { ResourcesPageComponent } from './componenets/resources-page/resources-page.component';
import { InitiativesPageComponent } from './componenets/initiatives-page/initiatives-page.component';
import { CSRSportComponent } from './componenets/csrsport/csrsport.component';
import { PartnerregisterPageComponent } from './componenets/auth/partnerregister-page/partnerregister-page.component';
import { CorporatePageComponent } from './componenets/corporate-page/corporate-page.component';
import { CsrsdocListComponent } from './componenets/csrsdoc-page/csrsdoc-list/csrsdoc-list.component';
import { CsrsprojectdetailPageComponent } from './componenets/csrsprojectdetail-page/csrsprojectdetail-page.component';
import { CsrprojectDetailspageComponent } from './componenets/csrsprojectdetail-page/csrproject-detailspage/csrproject-detailspage.component';
import { CsrsListComponent } from './componenets/csrsprojectdetail-page/csrs-list/csrs-list.component';
import { CorporateProfileComponent } from './componenets/corporate-profile/corporate-profile.component';
import { CsrsdocaddPageComponent } from './componenets/csrsdocadd-page/csrsdocadd-page.component';
import { CsrsportNewPageComponent } from './componenets/csrsport-new-page/csrsport-new-page.component';
import { MapSectionComponent } from './componenets/map-section/map-section.component';
import { ChangePasswordComponent } from './componenets/auth/change-password/change-password.component';
import { ForgetPasswordComponent } from './componenets/auth/forget-password/forget-password.component';
import { CsrremarksComponent } from './componenets/csrsdoc-page/csrremarks/csrremarks.component';
import { NewsletterPageComponent } from './componenets/newsletter-page/newsletter-page.component';
// import { AccelatorsPageComponent } from './componenets/accelators-page/accelators-page.component';
import { NewcorporatePageComponent } from './componenets/newcorporate-page/newcorporate-page.component';
// import { AccelatorsPageComponent } from './componenets/newcorporate-page/accelators-page/accelators-page.component';
import { AccelatorsDetailsComponent } from './componenets/newcorporate-page/accelators-details/accelators-details.component';
// import { AccelatorsPageComponent } from './componenets/newcorporate-page/accelators-page/accelators-page.component';
import { AccelatorsListComponent } from './componenets/newcorporate-page/accelators-list/accelators-list.component';
import { ToiletPageComponent } from './componenets/toilet-page/toilet-page.component';
import { ToiletnewPageComponent } from './componenets/toiletnew-page/toiletnew-page.component';
import { NewpreIncubatorComponent } from './componenets/auth/newpre-incubator/newpre-incubator.component';
import { PreIncubatorListComponent } from './componenets/pages/pre-incubator-list/pre-incubator-list.component';
import { PreIncubationHomeComponent } from './componenets/pre-incubation-home/pre-incubation-home.component';
import { RegisterModalComponent } from './componenets/auth/register-modal/register-modal/register-modal.component';
import { EmailModalComponent } from './componenets/pages/email-modal/email-modal/email-modal.component';
import { SuccessExcelModalComponent } from './componenets/pages/email-modal/email-modal/success-excel-modal/success-excel-modal.component';
import { ConnectWithIncubatorListComponent } from './componenets/pages/ConnectwithIncubator-list/connect-with-incubator-list/connect-with-incubator-list.component';
import { ConnectWithIncubatorEmailComponent } from './componenets/pages/ConnectwithIncubator-list/ConnectWithIncubator-Email/connect-with-incubator-email/connect-with-incubator-email.component';
import { CoeHomePageComponent } from './componenets/Coe-home-page/coe-home-page.component';
import { CoeLoginPageComponent } from './componenets/auth/coe-login-page/coe-login-page.component';
import { CoeListComponent } from './componenets/pages/coe-list/coe-list.component';

@NgModule({
  declarations: [
    LayoutPageComponent,
    HomePageComponent,
    StartupPageComponent,
    IncubatorsListComponent,
    IncubatorsDetailsComponent,
    EventsPageComponent,
    GalleryPageComponent,
    BlogPageComponent,
    ContactPageComponent,
    NavbarComponent,
    FooterComponent,
    LoginPageComponent,
    RegisterPageComponent,
    EventListComponent,
    EventDetailsComponent,
    SafeHtmlPipe,
    BlogListComponent,
    BlogDetailsComponent,
    BrochureViewComponent,
    ProfilePageComponent,
    IncubatorListComponent,
    GoogleMapDialogBoxComponent,
    YoutubeDialogBoxComponent,
    TermsPageComponent,
    PolicyPageComponent,
    SearchPageComponent,
    IncuNewslettersComponent,
    ResourcesPageComponent,
    InitiativesPageComponent,
    CSRSportComponent,
    PartnerregisterPageComponent,
    CorporatePageComponent,
    CsrsdocListComponent,
    CsrsprojectdetailPageComponent,
    CsrprojectDetailspageComponent,
    CsrsListComponent,
    CorporateProfileComponent,
    CsrsdocaddPageComponent,
    MapSectionComponent,
    CsrsportNewPageComponent,
    ChangePasswordComponent,
    ForgetPasswordComponent,
    CsrremarksComponent,
    NewsletterPageComponent,
    // AccelatorsPageComponent,
    NewcorporatePageComponent,
    AccelatorsDetailsComponent,
    AccelatorsListComponent,
    ToiletPageComponent,
    ToiletnewPageComponent,
    NewpreIncubatorComponent,
    PreIncubatorListComponent,
    PreIncubationHomeComponent,
    RegisterModalComponent,
    EmailModalComponent,
    SuccessExcelModalComponent,
    ConnectWithIncubatorListComponent,
    ConnectWithIncubatorEmailComponent,
    CoeHomePageComponent,
    CoeLoginPageComponent,
    CoeListComponent,
    // InitiativesComponent
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    // RxReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
    GalleryModule,
    LightboxModule,
    NgxMatSelectSearchModule,
    PdfViewerModule,
  ],
  entryComponents: [
    GoogleMapDialogBoxComponent,
    BrochureViewComponent,
    YoutubeDialogBoxComponent,
  ],
})
export class HomeModule {}
